import React, { useState } from 'react';
import logo from './Bitdefenderlogo.png';
import './App.css';
import './button.css';
import CreateSurvey from './CreateSurvey';
import SurveyList from './SurveyList';
import PublicSurvey from './PublicSurvey';

function App() {
  const [page, setPage] = useState('home');
  const [surveyToEdit, setSurveyToEdit] = useState(null);
  const [publicSurveyId, setPublicSurveyId] = useState(null);
  const goHome = () => {
    setPage('home');
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('survey');
    if (sid) {
      setPublicSurveyId(sid);
      setPage('public');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      {page === 'home' && (
        <header className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-white to-blue-50 p-6">
          <img src={logo} className="w-auto h-auto mb-6 object-contain" alt="logo" />
          <h1 className="text-4xl font-bold mb-8 text-blue-900">Survey Editor</h1>
          <div className="flex gap-4">
            <button className="px-6 py-3 rounded-lg font-semibold transition-all bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-lg" onClick={() => { setSurveyToEdit(null); setPage('create'); }}>Start Create</button>
            <button className="px-6 py-3 rounded-lg font-semibold transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 shadow-md hover:shadow-lg" onClick={() => setPage('list')}>Survey List</button>
          </div>
        </header>
      )}

      {page === 'create' && <CreateSurvey goHome={goHome} survey={surveyToEdit} />}
      {page === 'list' && <SurveyList goHome={goHome} onEdit={(s) => { setSurveyToEdit(s); setPage('create'); }} />}
      {page === 'public' && <PublicSurvey surveyId={publicSurveyId} goHome={goHome} />}
    </div>
  );
}

export default App;
